/**
 * 根据权限配置菜单
 * 每一个menu项参数：label, path, number 显示提示数字, query 查询对象
 */
import Permit from '../utils/permit'
let menus = []
menus.push({ key: "dashboard", label: '主工作台', path: '/normal/dashboard', icon: 'dashboard' })
menus.push({ key: "perferenceUsers", label: '子账号', path: '/set/perference/users', icon: 'users' })
// menus.push({ key: "perferenceShops", label: '店铺', path: '/set/perference/shops', icon: 'shop' })
// menus.push({ key: "perferencePayMethods", label: '收付款方式', path: '/set/perference/pay-methods', icon: 'payMethod' })
let bargain = { key: "bargain", label: '订单', icon: 'product', children: [] }
bargain.children.push({ key: "perferenceShops", label: '店铺', path: '/set/perference/shops', icon: 'shop' })
bargain.children.push({ key: "perferencePayMethods", label: '收付款方式', path: '/set/perference/pay-methods', icon: 'payMethod' })
bargain.children.push({ key: "perferenceRentTemplates", label: '打印订单模版', path: '/set/perference/rent-templates', icon: 'shop' })
menus.push(bargain)

let pdm = { key: "pdm", label: '产品', icon: 'product', children: [] }
pdm.children.push({ key: "perferencePdmCategories", label: '产品分类', path: '/set/perference/pdm/categories' })
pdm.children.push({ key: "perferencePdmCategoriesServe", label: '服务分类', path: '/set/perference/pdm/categories-serve' })
pdm.children.push({ key: "perferencePdmUnits", label: '单位', path: '/set/perference/pdm/units' })
pdm.children.push({ key: "perferencePdmColors", label: '颜色', path: '/set/perference/pdm/colors' })
pdm.children.push({ key: "perferencePdmSizes", label: '规格', path: '/set/perference/pdm/sizes' })
pdm.children.push({ key: "perferencePdmBrands", label: '品牌', path: '/set/perference/pdm/brands' })
menus.push(pdm)
menus.push({ key: "perferenceScheduleTypes", label: '预约类型', path: '/set/perference/schedule-types', icon: 'schedules' })
menus.push({ key: "perferenceSuppliers", label: '供应商', path: '/set/perference/suppliers', icon: 'suppliers' },)
menus.push({ key: "perferenceSources", label: '来源类型', path: '/set/perference/sources', icon: 'suppliers' },)
menus.push({ key: "perferenceSettings", label: '系统设置', path: '/set/perference/settings', icon: 'set' })


export default {
  items: menus.filter(menu => !menu.children || (menu.children && menu.children.length != 0))
};